import React, {Component} from "react";
import TopNav from "../../../common/nav/TopNav";
import Footer from "../../../common/Footer";
import PageBlock from "../../../common/PageBlock";

class BuildSystems extends Component {
    render() {
        return (
            <div>
                <TopNav tab="docs"/>

                <PageBlock>
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12 m-b-md">
                                <h1 className="page-header">Build Systems</h1>
                                <h4 className="text-muted">Jenkins, Rundeck etc.</h4>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <p>We work with the tools teams use every day to build and deploy software,
                                    like Jenkins and Rundeck.
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <blockquote>Content coming soon.</blockquote>
                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default BuildSystems;



// WEBPACK FOOTER //
// ./src/modules/views/docs/bot/BuildSystems.js